/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function parseLeadingNumber(str) {
    var match = (str || '').trim().match(/^(\d+)/);
    return match ? parseInt(match[1], 10) : 0;
  }

  function updateLegendText(field) {
    var checked = field.querySelector('input[type="radio"]:checked');
    var legendValue = field.querySelector('[data-option-value]');
    // Cleared when nothing is picked: the theme writes the stone count into
    // every [data-option-value] inside the wrapper on variant change.
    if (legendValue) {
      legendValue.textContent = checked ? checked.value : '';
    }
  }

  function setFieldVisibility(field, stoneCount, noDefault) {
    var min = parseInt(field.getAttribute('data-min-stones'), 10);
    var inputs = field.querySelectorAll('input[type="radio"]');
    var shouldShow = stoneCount >= min;

    if (shouldShow) {
      field.hidden = false;
      inputs.forEach(function (input) {
        input.disabled = false;
      });

      if (!noDefault && !field.querySelector('input[type="radio"]:checked') && inputs.length) {
        inputs[0].checked = true;
      }

      updateLegendText(field);
      setTimeout(function () {
        updateLegendText(field);
      }, 0);
    } else {
      field.hidden = true;
      inputs.forEach(function (input) {
        input.disabled = true;
      });
    }
  }

  function initBirthstoneExtraWrapper(wrapper) {
    if (wrapper.dataset.birthstoneExtraInit) return;
    wrapper.dataset.birthstoneExtraInit = 'true';

    var position = parseInt(wrapper.getAttribute('data-option-position'), 10) - 1;
    var fields = wrapper.querySelectorAll('[data-birthstone-extra-field]');
    // Property-mode pickers (snippets/birthstone-extra-stones.liquid) are required
    // and must stay unselected until the customer picks a stone.
    var noDefault = wrapper.hasAttribute('data-birthstone-no-default');

    fields.forEach(function (field) {
      updateLegendText(field);

      field.addEventListener('change', function (e) {
        if (e.target.matches('input[type="radio"]')) {
          updateLegendText(field);
        }
      });
    });

    document.addEventListener('theme:variant:change', function (evt) {
      var variant = evt.detail && evt.detail.variant;
      if (!variant || !evt.target.contains(wrapper)) return;

      var stoneCount = parseLeadingNumber(variant.options[position]);
      fields.forEach(function (field) {
        setFieldVisibility(field, stoneCount, noDefault);
      });
    });
  }

  function initAllBirthstoneExtraWrappers() {
    document.querySelectorAll('[data-birthstone-extra-wrapper]').forEach(initBirthstoneExtraWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBirthstoneExtraWrappers);
  } else {
    initAllBirthstoneExtraWrappers();
  }

  document.addEventListener('shopify:section:load', initAllBirthstoneExtraWrappers);

  // Chain add-on: Mother Halo's chain-add-on picker (snippets/chain-add-on.liquid)
  // renders "Add a Chain (+$550.00)" as a cart line item property checkbox, not a
  // real variant, so Shopify can't price it natively. Checking it adds a second
  // line item via a hidden product ("Chain Add-On (Mother Halo)", unlisted,
  // https://admin.shopify.com/store/juliannesjewelry/products/10360910119207).
  var CHAIN_ADD_ON_VARIANT_ID = 51970782101799;

  // Listen for theme:product:add (fired only after the primary item's own
  // /cart/add.js request has resolved) rather than theme:cart:add, so the two
  // /cart/add.js POSTs don't race and silently drop one of the line items.
  document.addEventListener('theme:product:add', function (event) {
    var button = event.detail && event.detail.button;
    if (!button) return;

    var form = button.closest('form');
    if (!form) return;

    var formData = new FormData(form);
    // Use getAll(), not get(): the picker submits both a hidden "No" fallback
    // and the checkbox's "Yes" value under the same property name (so Shopify's
    // own cart line item, which takes the last value server-side, shows "Yes"
    // when checked) — get() would return whichever entry is first in DOM order,
    // which is the wrong one here.
    var addChainValues = formData.getAll('properties[Add a Chain]');
    if (addChainValues.indexOf('Yes (+$550.00)') === -1) return;

    var quantity = parseInt(formData.get('quantity'), 10) || 1;

    fetch(window.theme.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{id: CHAIN_ADD_ON_VARIANT_ID, quantity: quantity}],
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        if (window.cart && typeof window.cart.getCart === 'function') {
          window.cart.getCart();
        }
      })
      .catch(function (error) {
        console.error('Chain add-on failed to add:', error);
      });
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
